module.exports = __webpack_public_path__ + "static/media/home-show-panel-mobile-loading.d4000719.svg";